import React, { useState, useEffect } from "react";
import { useIncomesService } from "../../../Services/Incomes";
import { useGetSucursal } from "../../../Services/Sucursales";
import {
    Button,
    Modal,
    Box,
    TextField,
    MenuItem,
    CircularProgress,
    InputAdornment,
    Stack,
    Autocomplete,
    Grid,
    Typography
} from "@mui/material";
import { useTypeIncomes } from "../../../Services/TypeIncome";
import { CalendarToday } from "@mui/icons-material";
import { IoClose } from "react-icons/io5";
import { BiErrorCircle } from "react-icons/bi";
import { FaRegCircleCheck } from "react-icons/fa6";
import { buttonGuardar, inputFecha, Input, buttonCancelar, InputDescripcion, buttonCerrar } from "../../../Layouts/CustomStyles";
import { useGetContact } from "../../../Services/Incomes";
import { useGetProfesional } from "../../../Services/Profesional";

export const EditarIncome = ({ income, onClose, onUpdated }) => {
    const { putIncomes } = useIncomesService();
    const { sucursales } = useGetSucursal();
    const { contacts, searchContacts } = useGetContact();
    const { profesional } = useGetProfesional();
    const { incomeTypes, loadings, error } = useTypeIncomes();
    const [loading, setLoading] = useState(false);
    const [successAlertOpen, setSuccessAlertOpen] = useState(false);
    const [errorAlertOpen, setErrorAlertOpen] = useState(false);
    const [enviandoAlert, setEnviandoAlert] = useState(false);
    const [alertMessage, setAlertMessage] = useState('');
    const [formData, setFormData] = useState(income);
    const [details, setDetails] = useState([]);
const [showDetails, setShowDetails] = useState(false);
const [selectedContact, setSelectedContact] = useState(null);

useEffect(() => {
 searchContacts(); // 👈 SIN q
}, []);

useEffect(() => {
  if (income?.details) {
    setDetails(income.details);
    setShowDetails(income.details.length > 0);
  }
}, [income]);
const handleAddDetail = () => {
  setDetails(prev => [...prev, {
    branch_id: "",
    amount: "",
    description: ""
  }]);
};

const handleRemoveDetail = (index) => {
  const updated = details.filter((_, i) => i !== index);
  setDetails(updated);
};

const handleChangeDetail = (index, field, value) => {
  const updated = [...details];
  updated[index][field] = value;
  setDetails(updated);
};

const totalDetalles = details.reduce(
  (acc, d) => acc + Number(d.amount || 0),
  0
);
    useEffect(() => {
  if (income) {
    setFormData({
      id: income.id,
      income_type_id: income.income_type_id,
      branch_id: income.branch_id,
      date: income.date,
      due_date: income.due_date,
      contact_id: income.contact_id,
      id_profesional: income.id_profesional,
      concept: income.concept,
      total_amount: income.total_amount,
      estado: income.estado,
    });
  }
}, [income]);

useEffect(() => {
  if (income?.contact) {
    setSelectedContact(income.contact);

    setFormData(prev => ({
      ...prev,
      contact_id: income.contact.id,
      showNewContactFields: false,
    }));
  }
}, [income]);

    const handleChange = (e) => {
        setFormData({ ...formData, [e.target.name]: e.target.value });
    };


   const handleSubmit = async (e) => {
  e.preventDefault();
  setLoading(true);
  setEnviandoAlert(true);

  try {
    let payload = { ...formData };


    if (showDetails && details.length > 0) {

      const totalDetalles = details.reduce(
        (acc, d) => acc + Number(d.amount || 0),
        0
      );

  
      if (totalDetalles !== Number(formData.total_amount)) {
        setErrorAlertOpen(true);
        setAlertMessage("El total distribuido no coincide con el monto total");
        setLoading(false);
        setEnviandoAlert(false);
        return;
      }

      payload.details = details.map(d => ({
        id: d.id || undefined, 
        branch_id: d.branch_id,
        amount: Number(d.amount),
        description: d.description || null
      }));
    } else {
      
      payload.details = [];
    }

    // 🚀 REQUEST
    await putIncomes(formData.id, payload);

    setSuccessAlertOpen(true);
    setAlertMessage("Se ha editado correctamente.");

    if (onUpdated) onUpdated();
    onClose();

  } catch (err) {
    console.error("Error al editar ingreso:", err);
    setErrorAlertOpen(true);
    setAlertMessage(
      err?.response?.data?.message ||
      "Ocurrió un error inesperado al editar el ingreso."
    );
  } finally {
    setLoading(false);
    setEnviandoAlert(false);
  }
};
    const formatCLP = (value) => {
        if (!value) return "";
        return new Intl.NumberFormat("es-CL", {
            style: "currency",
            currency: "CLP",
            minimumFractionDigits: 0,
        }).format(value);
    };

    const parseCLP = (value) => {
        // elimina todo lo que no sea número
        return Number(value.replace(/[^0-9]/g, "")) || 0;
    };
    return (
        <>
            <form onSubmit={handleSubmit}>
                {loadings && (
                    <MenuItem disabled>
                        <CircularProgress size={18} />
                        Cargando...
                    </MenuItem>
                )}
                {error && <MenuItem disabled>{error}</MenuItem>}

                {!loadings && !error && (
                    <TextField
                        select
                        fullWidth
                        label="Tipo de Ingreso"
                        name="income_type_id"
                        sx={Input}
                        value={formData.income_type_id}
                        onChange={handleChange}
                        margin="normal"
                    >
                        {incomeTypes.map((type) => (
                            <MenuItem key={type.id} value={type.id}>
                                {type.name}
                            </MenuItem>
                        ))}
                    </TextField>
                )}
                <TextField
                    select
                    fullWidth
                    label="Sucursal"
                    name="branch_id"
                    sx={Input}
                    value={formData.branch_id}
                    onChange={handleChange}
                    margin="normal"
                >
                    {sucursales.length > 0 ? (
                        sucursales.map((sucursal) => (
                            <MenuItem key={sucursal.id} value={sucursal.id}>
                                {sucursal.name} {/* 👈 se muestra el nombre */}
                            </MenuItem>
                        ))
                    ) : (
                        <MenuItem disabled>No hay sucursales disponibles</MenuItem>
                    )}
                </TextField>
                <TextField
                        select
                        fullWidth
                        label="Estado ingreso"
                        name="estado"
                        sx={Input}
                        value={formData.estado}
                        onChange={handleChange}
                        margin="normal"
                    >
                              <MenuItem value="REGISTRADO">registrado</MenuItem>
                           <MenuItem value="PENDIENTE">Pendiente</MenuItem>
                             <MenuItem value="PROCESO">Proceso</MenuItem>
                            <MenuItem value="NO PAGO">No pagado</MenuItem>
  <MenuItem value="PAGADO">Pagado</MenuItem>
  <MenuItem value="ANULADO">Anulado</MenuItem>
                       
                    </TextField>
                <Stack direction="row" spacing={2} mt={2}>
                    <TextField
                        fullWidth
                        label="Fecha"
                        name="date"
                        type="date"
                        value={formData.date}
                        onChange={handleChange}
                        margin="normal"
                        sx={{ ...inputFecha, width: '100%' }}
                        InputLabelProps={{ shrink: true }}
                        InputProps={{
                            endAdornment: (
                                <InputAdornment position="end">
                                    <CalendarToday />
                                </InputAdornment>
                            ),
                        }}
                    />

                    <TextField
                        fullWidth
                        label="Fecha Vencimiento"
                        name="due_date"
                        type="date"
                        sx={{ ...inputFecha, width: '100%' }}
                        value={formData.due_date}
                        onChange={handleChange}
                        margin="normal"
                        InputLabelProps={{ shrink: true }}
                        InputProps={{
                            endAdornment: (
                                <InputAdornment position="end">
                                    <CalendarToday />
                                </InputAdornment>
                            ),
                        }}
                    />
                </Stack>
                
                <Box mt={2}>
                    <Autocomplete
  sx={Input}
  options={contacts}
  value={selectedContact}
  getOptionLabel={(option) =>
    option ? `${option.name} - ${option.rut}` : ""
  }
  isOptionEqualToValue={(option, value) =>
    option.id === value.id
  }
  onInputChange={(e, value) => {
    searchContacts(value);
  }}
  onChange={(e, value) => {
    setSelectedContact(value);

    if (value) {
      setFormData(prev => ({
        ...prev,
        contact_id: value.id,
        rut_contacto: "",
        name_contacto: "",
        email_contacto: "",
        phone_contacto: "",
        showNewContactFields: false,
      }));
    } else {
      setFormData(prev => ({
        ...prev,
        contact_id: null,
      }));
    }
  }}
  renderInput={(params) => (
    <TextField {...params} label="Buscar contacto" />
  )}
/>

{!selectedContact && !formData.showNewContactFields && (
  <Button
    variant="outlined"
    sx={{ mt: 1 }}
    onClick={() =>
      setFormData(prev => ({ ...prev, showNewContactFields: true }))
    }
  >
    Agregar contacto
  </Button>
)}

{formData.showNewContactFields && (
  <>
    <TextField
      fullWidth
      label="RUT"
      sx={Input}
      name="rut_contacto"
      value={formData.rut_contacto || ""}
      onChange={handleChange}
      margin="normal"
    />
    <TextField
      fullWidth
      label="Nombre"
      sx={Input}
      name="name_contacto"
      value={formData.name_contacto || ""}
      onChange={handleChange}
      margin="normal"
    />
    <TextField
      fullWidth
      label="Email"
      sx={Input}
      name="email_contacto"
      value={formData.email_contacto || ""}
      onChange={handleChange}
      margin="normal"
    />
    <TextField
      fullWidth
      label="Teléfono"
      sx={Input}
      name="phone_contacto"
      value={formData.phone_contacto || ""}
      onChange={handleChange}
      margin="normal"
    />
  </>
)}

                </Box>

{formData.id_profesional && (
  <TextField
    select
    fullWidth
    label="Profesional"
    name="id_profesional"
    sx={Input}
    value={formData.id_profesional}
    onChange={handleChange}
    margin="normal"
  >
    {profesional.map((p) => (
      <MenuItem key={p.id} value={p.id}>
        {p.nombre}
      </MenuItem>
    ))}
  </TextField>
)}


                <TextField
                    fullWidth
                    label="Descripcion de ingreso"
                    name="concept"
                    multiline
                    rows={2}
                    sx={InputDescripcion}
                    value={formData.concept}
                    onChange={handleChange}
                    margin="normal"
                />
                <TextField
                    fullWidth
                    label="Monto Total"
                    name="total_amount"
                    sx={Input}
                    value={formatCLP(formData.total_amount)} 
                    onChange={(e) =>
                        setFormData({
                            ...formData,
                            total_amount: parseCLP(e.target.value), 
                        })
                    }
                    margin="normal"
                />
                {/* BOTÓN */}
{!showDetails && (
  <Button
    variant="outlined"
    sx={{ ...buttonGuardar, mt: 2 }}
    onClick={() => {
      setShowDetails(true);
      if (details.length === 0) handleAddDetail();
    }}
  >
    Distribuir por sucursales
  </Button>
)}

{/* DETAILS */}
{showDetails && (
  <Box mt={3}>
    {details.map((item, index) => (
      <Grid container spacing={2} key={index} mb={2}>

        {/* Sucursal */}
        <Grid size={4}>
          <TextField
            select
            fullWidth
            label="Sucursal"
            value={item.branch_id}
            onChange={(e) =>
              handleChangeDetail(index, "branch_id", e.target.value)
            }
          >
            {sucursales.map((s) => (
              <MenuItem key={s.id} value={s.id}>
                {s.name}
              </MenuItem>
            ))}
          </TextField>
        </Grid>

        {/* Monto */}
        <Grid size={3}>
          <TextField
            fullWidth
            label="Monto"
            value={formatCLP(item.amount || 0)}
            onChange={(e) => {
              const valor = e.target.value
                .replace(/\./g, "")
                .replace(/\$/g, "")
                .replace(/\D/g, "");

              handleChangeDetail(index, "amount", valor);
            }}
          />
        </Grid>

        {/* Descripción */}
        <Grid size={4}>
          <TextField
            fullWidth
            label="Descripción"
            value={item.description || ""}
            onChange={(e) =>
              handleChangeDetail(index, "description", e.target.value)
            }
          />
        </Grid>

        {/* Eliminar */}
        <Grid size={1}>
          <Button color="error" onClick={() => handleRemoveDetail(index)}>
            X
          </Button>
        </Grid>
      </Grid>
    ))}

    <Box display="flex" gap={2}>
      <Button sx={buttonGuardar} onClick={handleAddDetail}>
        + Agregar sucursal
      </Button>

      <Button
       sx={buttonCancelar}
        onClick={() => {
          setShowDetails(false);
          setDetails([]);
        }}
      >
        Cancelar
      </Button>
    </Box>

    <Typography mt={2}>
      Total distribuido: {formatCLP(totalDetalles)}
    </Typography>
  </Box>
)}
                <Stack direction="row" spacing={2} mt={2}>
                    <Button onClick={onClose} sx={buttonCancelar}>
                        Cancelar
                    </Button>
                    <Button type="submit" sx={buttonGuardar}>
                        {loading ? (
                            <CircularProgress size={20} color="inherit" /> // spinner pequeño dentro
                        ) : (
                            "Guardar"
                        )}
                    </Button>
                </Stack>
            </form>


            <Modal open={successAlertOpen} onClose={() => setSuccessAlertOpen(false)}>
                <Box
                    sx={{
                        position: 'absolute',
                        top: '50%',
                        left: '50%',
                        transform: 'translate(-50%, -50%)',
                        width: '350px',
                        height: 'auto',
                        bgcolor: '#ffff',
                        boxShadow: 24,
                        p: 1,
                        borderRadius: '10px',
                        '@media (max-width: 500px)': {
                            width: '90%',
                        },
                    }}
                >
                    <section className="closemodal" onClick={() => setSuccessAlertOpen(false)}>
                        <IoClose />
                    </section>
                    <section style={{ textAlign: 'center' }}>
                        <FaRegCircleCheck style={{ color: 'green', fontSize: '2rem', marginBottom: '1rem' }} />
                        <p style={{ fontFamily: 'Poppins', color: '#585857', fontSize: '0.8rem', fontWeight: '600', marginTop: "-5px" }}>
                            {alertMessage}
                        </p>
                    </section>
                </Box>
            </Modal>

            <Modal open={errorAlertOpen} onClose={() => setErrorAlertOpen(false)}>
                <Box
                    sx={{
                        position: 'absolute',
                        top: '50%',
                        left: '50%',
                        transform: 'translate(-50%, -50%)',
                        width: '350px',
                        height: 'auto',
                        bgcolor: '#ffff',
                        boxShadow: 24,
                        p: 1,
                        borderRadius: '10px',
                        '@media (max-width: 500px)': {
                            width: '90%',
                        },
                    }}
                >
                    <section className="closemodal" onClick={() => setErrorAlertOpen(false)}>
                        <IoClose />
                    </section>
                    <section style={{ textAlign: 'center' }}>
                        <BiErrorCircle style={{ color: 'red', fontSize: '2rem', marginBottom: '1rem' }} />
                        <p style={{ fontFamily: 'Poppins', color: '#585857', fontSize: '0.8rem', fontWeight: '600' }}>
                            {alertMessage}
                        </p>
                    </section>
                </Box>
            </Modal>

            <Modal open={enviandoAlert} onClose={() => setEnviandoAlert(false)}>
                <Box
                    sx={{
                        position: 'absolute',
                        top: '50%',
                        left: '50%',
                        transform: 'translate(-50%, -50%)',
                        width: '350px',
                        height: 'auto',
                        bgcolor: '#ffff',
                        boxShadow: 24,
                        p: 1,
                        borderRadius: '10px',
                        '@media (max-width: 500px)': {
                            width: '90%',
                        },
                    }}
                >
                    <section style={{ textAlign: 'center', padding: '1rem' }}>
                        <CircularProgress style={{ color: '#e83b33' }} />
                        <p style={{ fontFamily: 'Poppins', color: '#585857', fontSize: '0.8rem', fontWeight: '600', marginTop: '20px' }}>
                            Procesando solicitud...
                        </p>
                    </section>
                </Box>
            </Modal>
        </>
    )
}